@let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
<div class="video-settings-container">
  <div class="video-header">
    @if (brandingService.brandingData$ | async; as brandingData) {
      <button
        class="rescan-button"
        (click)="scanDevices()"
        appBrandingColor
        [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
        styleType="color"
        [style.--hover-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
        {{ 'VIDEO_SETTINGS_PREFERENCES.RESCAN_DEVICES' | translate }}
      </button>
    }
  </div>
  <div class="webcam-container">
    @if (cameraError) {
      <div class="error-message">{{ 'VIDEO_SETTINGS_PREFERENCES.NO_CAMERA' | translate }}</div>
    } @else {
      <video
        class="webcam"
        #video
        id="video"
        width="530"
        autoplay="autoplay"
        [ngClass]="{ mirrorVideo: mirrorLocalVideo, normalVideo: !mirrorLocalVideo }"></video>
    }
  </div>
  @if (activeCameraList.length > 0) {
    <mat-form-field
      class="full form-no-error select-list-container"
      color="primary"
      appearance="outline">
      <mat-label>{{ 'VIDEO_SETTINGS_PREFERENCES.CAMERA' | translate }}</mat-label>
      <mat-select
        [disabled]="activeCameraList.length === 1"
        class="select-list-label"
        [(value)]="selectedCamera"
        (selectionChange)="onCameraChanged($event.value)">
        @for (item of activeCameraList; track item.deviceId) {
          <mat-option
            class="select-list-item"
            [value]="item">
            {{ item.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <form [formGroup]="form">
    <div class="flex-col">
      <mat-checkbox
        formControlName="mirrorLocalVideo"
        (change)="onFormChange()"
        color="primary"
        [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
        >{{ 'VIDEO_SETTINGS_PREFERENCES.MIRROR_LOCAL_VIDEO' | translate }}
      </mat-checkbox>
      <mat-checkbox
        formControlName="blurBackground"
        name="blurBackgroundCheckbox"
        (change)="onBackgroundStatusChange($event)"
        color="primary"
        [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
        >{{ 'VIDEO_SETTINGS_PREFERENCES.BLUR_BACKGROUND_DURING_CALLS' | translate }}
      </mat-checkbox>
      <mat-checkbox
        formControlName="cameraOn"
        (change)="onFormChange()"
        color="primary"
        [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
        >{{ 'VIDEO_SETTINGS_PREFERENCES.CAMERA_WHEN_ENTERING_MEETING' | translate }}
      </mat-checkbox>
    </div>
  </form>
</div>
